/** A day-of-month choice: a calendar day number, or the month's last day whatever its number. */
export type DayOfMonthValue = number | 'last';

/** The "Last day" cell's value, so call sites never spell the literal themselves. */
export const LAST_DAY_OF_MONTH: DayOfMonthValue = 'last';

/** Highest day number that exists in every month — above this, short months need the fallback note. */
export const SHORTEST_MONTH_LENGTH = 28;

/** Rows of the grid: four full weeks, then the short tail that the "Last day" cell shares. */
export const DAY_OF_MONTH_ROWS: readonly (readonly number[])[] = [
  [1, 2, 3, 4, 5, 6, 7],
  [8, 9, 10, 11, 12, 13, 14],
  [15, 16, 17, 18, 19, 20, 21],
  [22, 23, 24, 25, 26, 27, 28],
];

/** The final row's day numbers, which sit beside the "Last day" cell. */
export const DAY_OF_MONTH_TAIL: readonly number[] = [29, 30, 31];

/** Adds or removes a day, leaving the rest of the selection alone. */
export function toggleDayOfMonth(current: readonly DayOfMonthValue[], day: DayOfMonthValue): DayOfMonthValue[] {

  return current.includes(day) ? current.filter(value => value !== day) : [...current, day];
}

/**
 * True when the selection contains a day that some months do not have, which is the only case where the
 * "use the last day instead" fallback actually fires. `'last'` never triggers it — it means the last
 * day by definition, so there is nothing to fall back from.
 */
export function needsLastDayFootnote(current: readonly DayOfMonthValue[]): boolean {

  return current.some(value => typeof value === 'number' && value > SHORTEST_MONTH_LENGTH);
}
